module.exports = __webpack_public_path__ + "img/pomaude-train.3afcf8d.jpg";